import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComplianceAdminService } from '../../../_core/_services/_compliance/compliance-admin.service';
import { NotificationService } from '../../../_core/_services/notification.service';
import { ApiMeta } from '../../../_core/_model/api-response';

@Component({
  selector: 'app-admin-jurisdictions-list',
  standalone: false,
  templateUrl: './admin-jurisdictions-list.html',
  styleUrl: './admin-jurisdictions-list.css',
})
export class AdminJurisdictionsList implements OnInit {
  private readonly filterStorageKey = 'admin-compliance-jurisdictions-filter';

  meta: ApiMeta | null = null;

  url: any;

  loading: boolean = false;
  error: string | null = null;
  items: any[] = [];

  page: number = 1;

  defaultFilter = {
    search: '',
    isActive: '',
    isGlobalFallback: '',
    page: this.page,
    pageSize: ''
  };

  filter = { ...this.defaultFilter };

  constructor(
    private adminService: ComplianceAdminService,
    private router: Router,
    private notifyService: NotificationService,
  ) {
    this.url = this.router.url.slice(1);
  }

  ngOnInit(): void {
    this.restoreFilters();
    this.load();
  }

  onPageLoad(page:number) {
    this.page = page;
    this.filter.page = page;
    this.restoreFilters();
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;

    const payload: any = {
      page: this.filter.page
    };

    if (this.filter.search) payload.search = this.filter.search;
    if (this.filter.isActive !== '') payload.isActive = this.filter.isActive;
    if (this.filter.isGlobalFallback !== '') payload.isGlobalFallback = this.filter.isGlobalFallback;
    if (this.filter.pageSize) payload.pageSize = this.filter.pageSize;

    this.persistFilters();

    this.adminService.getJurisdictions(payload).subscribe({
      next: (res: any) => {
        this.meta = res?.meta;
        this.items = res?.data || res?.items || res || [];
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.error?.message || 'Failed to load jurisdictions.';
        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      }
    });
  }

  createNew(): void {
    this.persistFilters();
    this.router.navigate(['/admin/compliance/jurisdictions/new']);
  }

  edit(item: any): void {
    this.persistFilters();
    this.router.navigate(['/admin/compliance/jurisdictions', item.id, 'edit']);
  }

  resetFilters(): void {
    this.filter = { ...this.defaultFilter };
    this.clearPersistedFilters();
    this.load();
  }

  persistFilters(): void {
    sessionStorage.setItem(this.filterStorageKey, JSON.stringify(this.filter));
  }

  restoreFilters(): void {
    const raw = sessionStorage.getItem(this.filterStorageKey);
    if (!raw) return;

    try {
      const saved = JSON.parse(raw);
      this.filter = {
        ...this.defaultFilter,
        ...saved,
        page: Number(saved?.page || this.defaultFilter.page),
        pageSize: Number(saved?.pageSize || this.defaultFilter.pageSize)
      };
    } catch {
      this.filter = { ...this.defaultFilter };
    }
  }

  clearPersistedFilters(): void {
    sessionStorage.removeItem(this.filterStorageKey);
  }

  asYesNo(value: any): string {
    return value ? 'Yes' : 'No';
  }

  statusBadgeClass(value: any): string {
    return value ? 'text-bg-success' : 'text-bg-secondary';
  }
}